import React, { useState } from 'react'
import {useIntl} from 'react-intl'

import {
    Box,
    RadioGroup,
    Radio,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui';
import {Tooltip} from '@chakra-ui/react'
import StoreSelectorModal from '../store-selector-modal'
import StoreDetails from '../store-details/insex';
import {fonts} from '../../theme/foundations/fonts';
import {pxToRem} from '../../utills/pxToRem';
import useUpdateShopperContext from '../store-selector-modal/updateShopperContext';
import {storeShipmentButtonStyles, shipToMeTooltipStyle} from './index.styles';

const DeliveryAddress = ({ product, quantity, updateDeliceryType, storePickUp, setStorePickUp, marginTop, setQuantity, minOrderQuantity }) => {
    const intl = useIntl()
    const { shopperContext } = useUpdateShopperContext()

    const {
        isOpen: isOpenStoreSelector,
        onOpen: onOpenStoreSelector,
        onClose: onCloseStoreSelector
    } = useDisclosure()

    const handleDeliveryAddressChange = (e) => {
        setStorePickUp(e),
        updateDeliceryType && updateDeliceryType(e)
        setQuantity && setQuantity(minOrderQuantity)
    }

    return (
        <>
            <RadioGroup
                variant="outline"
                value={storePickUp}
                sx={storeShipmentButtonStyles}
                onChange={(e) => handleDeliveryAddressChange(e)}
            >
                <Box className="radio" marginTop={marginTop}>
                    {product?.c_shipToHomeOnPWA?.showShipToHome && (
                        <Radio
                            value="shipToMe"
                            isDisabled={!product.c_shipToHomeOnPWA.enableShipToHome}
                        >
                            {intl.formatMessage({
                                id: 'product_list.store.shiptome',
                                defaultMessage: 'Ship to Me'
                            })}
                        </Radio>
                    )}
                    {product?.c_instorePickupOnPWA?.showInStorePickup && (
                        <Tooltip
                            isDisabled={
                                product.c_instorePickupOnPWA.enableInStorePickup
                            }
                            label={intl.formatMessage({
                                id: 'product_list.store.pickupinstore.toolip',
                                defaultMessage: "Select a size to see availability"
                            })} sx={shipToMeTooltipStyle}>
                            <Box>
                                <Radio
                                    value="pickUpInStore"
                                    isDisabled={
                                        !product.c_instorePickupOnPWA.enableInStorePickup
                                    }
                                >
                                    {intl.formatMessage({
                                        id: 'product_list.store.pickupinstore',
                                        defaultMessage: 'Pick Up in Store'
                                    })}
                                </Radio>
                            </Box>
                        </Tooltip>
                    )}
                </Box>
            </RadioGroup>

            {/* my store */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '16px',
                    marginTop:pxToRem(16)
                }}
            >
                {/* selected store details */}
                <StoreDetails />
                {/* change store button */}
                <Box
                    as="button"
                    color="cav_calltoaction_darkred"
                    fontSize={{ base: pxToRem(10), md: pxToRem(12) }}
                    fontFamily={fonts.primary}
                    textDecoration={'underline'}
                    textTransform={'uppercase'}
                    fontWeight={500}
                    lineHeight= "normal"
                    letterSpacing={pxToRem(1)}
                    _hover={{
                        textDecoration: 'none'
                    }}
                    onClick={() => onOpenStoreSelector()}
                >
                    {shopperContext && Object.keys(shopperContext.customQualifiers?.storeDetails)?.length
                        ? intl.formatMessage({
                            id: 'product_list.store.change.label',
                            defaultMessage: 'Change'
                        })
                        : intl.formatMessage({
                            id: 'product_list.store.selectSore.label',
                            defaultMessage: 'Select a store'
                        })}
                </Box>
            </Box>

            {/* store selector modal */}
            <StoreSelectorModal
                isOpen={isOpenStoreSelector}
                onClose={onCloseStoreSelector}
                isPdp={true}
                quantity={quantity}
                masterProductId={product?.master?.masterId}
                productId={product?.id}
                isMaster={Boolean(product?.type?.master)}
            />
        </>
    )
}

export default DeliveryAddress;